import script from "./PageReportsSystemHouse.vue?vue&type=script&setup=true&lang=js"
export * from "./PageReportsSystemHouse.vue?vue&type=script&setup=true&lang=js"

import "./PageReportsSystemHouse.vue?vue&type=style&index=0&id=62b63ecd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62b63ecd"]])

export default __exports__